import React from 'react';

export default React.createClass({
  render(){
    return (
      <div className="page-wrapper">
        {this.props.children}
      </div>
      )
  }
});